import Mentoring from './container';

export default Mentoring;
